// // import React, { Component } from "react";
// // import { Navigate } from "react-router";
// // import { connect } from "react-redux";
// // import {checkUserRunningOrder, getRunningOrders} from "../../../../services/user/actions";
// //
// // class Orders extends Component {
// //     state = {
// //         running_order: null,    // null = loading, true = running, false = not running
// //         updatedUserInfo: false,
// //         cancelSuccess: false,
// //     };
// //
// //     componentDidMount() {
// //         console.log("MOUNT props:", this.props);
// //
// //         const { user } = this.props;
// //         if (user.success) {
// //             this.props.checkUserRunningOrder(user.data.id, user.data.auth_token);
// //         }
// //
// //     }
// //
// //     componentDidUpdate(prevProps) {
// //         console.log("UPDATE fired");
// //
// //         // detect running_order change from Redux
// //         if (prevProps.running_order !== this.props.running_order) {
// //             console.log(
// //                 "running_order changed:",
// //                 prevProps.running_order,
// //                 "→",
// //                 this.props.running_order
// //             );
// //
// //             this.setState({
// //                 running_order: this.props.running_order,
// //             });
// //
// //             if(this.props.running_order) {
// //                 const { user } = this.props;
// //                 this.props.getRunningOrders(user.data.id, user.data.auth_token);
// //             }
// //
// //
// //             this.refreshSetInterval = setInterval(() => {
// //                 this.__refreshOrderStatus();
// //             }, 15 * 1000);
// //         }
// //
// //         // detect cancel change
// //         if (prevProps.cancel !== this.props.cancel) {
// //             if (this.props.cancel?.success) {
// //                 this.setState({ cancelSuccess: true });
// //
// //                 if (this.props.user.success) {
// //                     window.location.reload();
// //                 }
// //             }
// //         }
// //     }
// //
// //     __refreshOrderStatus = () => {
// //         const { user } = this.props;
// //         if (user.success) {
// //             this.props.getRunningOrders(user.data.id, user.data.auth_token);
// //         }
// //     };
// //
// //     componentWillUnmount() {
// //         console.log("UNMOUNTED component");
// //     }
// //
// //     render() {
// //         const { user } = this.props;
// //         const { running_order } = this.state;
// //
// //         console.log("RENDER props:", this.props);
// //         console.log("RENDER state:", this.state);
// //         console.log("Running Orders: ", this.props.running_orders);
// //         console.log("User: ", user);
// //
// //         if (window.innerWidth > 768) return <Navigate to="/" />;
// //         // if (!user.success) return <Navigate to="/login" />;
// //
// //         // still loading running_order (waiting for Redux)
// //         if (running_order === null) {
// //             return (<div style={{position: "absolute", backgroundColor: "red", bottom: 80, width: "100%"}}>
// //                 <p>Running Order FOUND</p>
// //             </div>);
// //         }
// //
// //         // no running order
// //         if (running_order === false) {
// //             return (<div style={{position: "absolute", backgroundColor: "red", bottom: 80, width: "100%"}}>
// //                 <p>Running Order FOUND</p>
// //             </div>);
// //         }
// //
// //         // has running order
// //         return (<div style={{position: "absolute", backgroundColor: "red", bottom: 80, width: "100%"}}>
// //             <p>Running Order FOUND</p>
// //         </div>);
// //     }
// // }
// //
// // const mapStateToProps = (state) => ({
// //     user: state.user.user,
// //     cancel: state.orders.cancel,
// //     running_order: state.user.running_order,   // <-- comes from Redux
// //     running_orders: state.user.running_orders
// // });
// //
// // export default connect(
// //     mapStateToProps,
// //     { checkUserRunningOrder, getRunningOrders }
// // )(Orders);
//
//
// import React, {Component} from "react";
// import {connect} from "react-redux";
// import {checkUserRunningOrder, getRunningOrders} from "../../../../services/user/actions";
//
// class Orders extends Component {
//     state = {
//         running_order: null,    // null = loading, true = running, false = not running
//     };
//
//     componentDidMount() {
//         console.log("MOUNT props:", this.props);
//         const {user} = this.props;
//         if (user.success) {
//             this.props.checkUserRunningOrder(user.data.id, user.data.auth_token);
//         }
//     }
//
//     componentDidUpdate(prevProps) {
//         console.log("UPDATE fired");
//         console.log("Prev Props: ", prevProps);
//         console.log("Next Props: ", this.props);
//
//         // detect running_order change from Redux every time this will change
//         // because date time is change and also we need to update like that
//         if (prevProps.running_order !== this.props.running_order) {
//             this.setState({
//                 running_order: this.props.running_order?.running_order,
//             });
//
//             const {user} = this.props;
//             if (user.success) {
//                 this.props.getRunningOrders(user.data.id, user.data.auth_token);
//             }
//
//             this.refreshSetInterval = setInterval(() => {
//                 this.__refreshOrderStatus();
//             }, 30 * 1000);
//         }
//     }
//
//
//     __refreshOrderStatus = () => {
//         const {user} = this.props;
//         if (user.success) {
//             this.props.getRunningOrders(user.data.id, user.data.auth_token);
//             this.setState({updatedUserInfo: true});
//         }
//     };
//
//     componentWillUnmount() {
//         console.log("UNMOUNTED component");
//
//
//         // Todo: May be clear the restaurant order status id.
//     }
//
//     render() {
//         const running_orders = [
//             {
//                 restaurant_name: "Pizza Palace",
//                 items: ["Pepperoni Pizza", "Garlic Bread", "Coke"],
//                 item_images: [
//                     "https://via.placeholder.com/80x80?text=Pizza",
//                     "https://via.placeholder.com/80x80?text=Bread",
//                     "https://via.placeholder.com/80x80?text=Coke"
//                 ],
//                 status: "preparing",
//                 total_price: 25.99
//             },
//             {
//                 restaurant_name: "Sushi World",
//                 items: ["California Roll", "Miso Soup", "Green Tea"],
//                 item_images: [
//                     "https://via.placeholder.com/80x80?text=Sushi",
//                     "https://via.placeholder.com/80x80?text=Soup",
//                     "https://via.placeholder.com/80x80?text=Tea"
//                 ],
//                 status: "on_the_way",
//                 total_price: 32.50
//             },
//             {
//                 restaurant_name: "Burger Hub",
//                 items: ["Cheeseburger", "Fries", "Pepsi"],
//                 item_images: [
//                     "https://via.placeholder.com/80x80?text=Burger",
//                     "https://via.placeholder.com/80x80?text=Fries",
//                     "https://via.placeholder.com/80x80?text=Pepsi"
//                 ],
//                 status: "delivered",
//                 total_price: 18.75
//             }
//         ];
//
//         const statusColors = {
//             preparing: "#fbc02d",
//             on_the_way: "#1976d2",
//             delivered: "#4caf50",
//             cancelled: "#e53935"
//         };
//
//         return (
//             <div
//                 style={{
//                     display: "flex",
//                     overflowX: "auto",
//                     scrollbarWidth: "none",
//                     msOverflowStyle: "none",
//                     WebkitOverflowScrolling: "touch",
//                     scrollSnapType: "x mandatory",
//                     gap: "10px",
//                     right: "1%",
//                     width: "98%",
//                     height: 60, // reduced height
//                     alignItems: "center",
//                     position: "absolute",
//                     bottom: 80, // closer to bottom
//                     backgroundColor: "#fff",
//                     borderRadius: 15, // smaller radius
//                     boxShadow: "0 3px 15px rgba(0,0,0,0.15)", // softer shadow
//                     padding: "2px 4px",
//                 }}
//             >
//                 {running_orders.map((order, idx) => (
//                     <div
//                         key={idx}
//                         style={{
//                             flexShrink: 0,
//                             scrollSnapAlign: "center",
//                             borderRadius: 15,
//                             display: "flex",
//                             alignItems: "center",
//                             gap: "8px",
//                             minWidth: "100%",
//                             height: "100%",
//                             padding: "0 15px 0 5px",
//                         }}
//                     >
//                         {/* Image */}
//                         <div
//                             style={{
//                                 display: "flex",
//                                 position: "relative",
//                                 width: 60, // smaller container
//                                 height: 50,
//                             }}
//                         >
//                             <img
//                                 src="https://blog.travelkhana.com/tkblog/wp-content/uploads/sites/2/2023/02/A-to-Z-Food-1024x683.jpg"
//                                 alt={`item-${idx}`}
//                                 style={{
//                                     width: 50,
//                                     height: 50,
//                                     borderRadius: 10,
//                                     objectFit: "cover",
//                                     position: "absolute",
//                                     left: 10,
//                                     boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
//                                 }}
//                             />
//                         </div>
//
//                         {/* Text content */}
//                         <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
//                             <div style={{ fontWeight: "bold", fontSize: 14, textAlign: "left" }}>
//                                 {order.restaurant_name}
//                             </div>
//                             <div
//                                 style={{
//                                     display: "flex",
//                                     flexDirection: "row",
//                                     justifyContent: "space-between",
//                                     alignItems: "center",
//                                     width: "100%",
//                                 }}
//                             >
//                         <span style={{ fontWeight: "bold", fontSize: 12 }}>
//                             ${order.total_price.toFixed(2)}
//                         </span>
//                                 <span
//                                     style={{
//                                         backgroundColor: "#6fda47",
//                                         fontWeight: "600",
//                                         fontSize: 12,
//                                         textTransform: "capitalize",
//                                         padding: "4px 8px",
//                                         borderRadius: 8,
//                                     }}
//                                 >
//                             {order.status.replace("_", " ")}
//                         </span>
//                             </div>
//                         </div>
//                     </div>
//                 ))}
//             </div>
//         );
//
//
//     }
//
//
// }
//
// const mapStateToProps = (state) => ({
//     user: state.user.user,
//     cancel: state.orders.cancel,
//     running_order: state.user.running_order,   // <-- comes from Redux
//     running_order_status: state.user.running_order_status
// });
//
// export default connect(
//     mapStateToProps,
//     {checkUserRunningOrder, getRunningOrders}
// )(Orders);


import React, {Component} from "react";
import {connect} from "react-redux";
import {checkUserRunningOrder, getRunningOrders, updateUserInfo} from "../../../../services/user/actions";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {placeOrder, resetCartAfterOrder} from "../../../../services/checkout/actions";
import {getRestaurantInfoById} from "../../../../services/items/actions";

class Orders extends Component {
    state = {
        loading: true,             // initial loading while checking running order
        running_order_exists: null, // null = loading, false = none, true = exists
        running_orders: [],        // fetched orders by status
        refreshing: false
    };

    componentDidMount() {
        const {user} = this.props;
        if (user.success) {
            this.setState({ refreshing: true });
            this.props.checkUserRunningOrder(user.data.id, user.data.auth_token);
        }
    }

    componentDidUpdate(prevProps) {
        const {is_running_orders, user, running_order_status} = this.props;

        // Detect when running order check completes
        if (prevProps.is_running_orders !== is_running_orders) {
            if (is_running_orders?.running_order) {
                this.setState({running_order_exists: true, loading: false});
                this.fetchRunningOrders();
                this.refreshSetInterval = setInterval(this.fetchRunningOrders, 15 * 1000);
            } else {
                this.setState({running_order_exists: false, loading: false});
            }
        }

        if (prevProps.running_order_status !== running_order_status) {
            this.setState({running_orders: running_order_status || []});
        }

        if (running_order_status?.length === 0) {
            clearInterval(this.refreshSetInterval);
        }
    }


    fetchRunningOrders = () => {
        const { user } = this.props;
        if (user.success) {
            this.props.getRunningOrders(user.data.id, user.data.auth_token);
            this.setState({ refreshing: true });
            setTimeout(() => {
                if (this.state.refreshing) {
                    this.setState({ refreshing: false });
                }
            }, 2 * 1000);
        }
    };


    componentWillUnmount() {
        // Clear interval on unmount
        if (this.refreshSetInterval) clearInterval(this.refreshSetInterval);
    }

    render() {
        const {loading, running_order_exists, running_orders} = this.state;

        if (!running_order_exists || loading) {
            return;
        }

        const statusMap = {
            1: "Order Placed",
            2: "Preparing Order",
            3: "Delivery Guy Assigned",
            4: "Order Picked Up",
            8: "Awaiting Payment",
        };

        const statusColors = {
            "Preparing Order": "#fbc02d",
            "Delivery Guy Assigned": "#1976d2",
            "Order Picked Up": "#fbc02d",
            "Order Placed": "#4caf50",
            "Awaiting Payment": "#e53935",
        };


        return (
            <>
                {running_orders?.length > 0 && (
                    <div
                        style={{
                            display: "flex",
                            overflowX: "auto",
                            gap: "10px",
                            width: "98%",
                            height: 90,
                            alignItems: "center",
                            position: "absolute",
                            bottom: 70,
                            backgroundColor: "#fff",
                            borderRadius: 15,
                            boxShadow: "0 3px 15px rgba(0,0,0,0.15)",
                            padding: "0px 5px",
                            alignSelf: "center",
                            scrollbarWidth: "none",
                            msOverflowStyle: "none",
                            WebkitOverflowScrolling: "touch",
                            scrollSnapType: "x mandatory",
                            WebkitTapHighlightColor: "transparent",
                        }}
                    >
                        {this.state.refreshing && (
                            <div
                                style={{
                                    position: "absolute",
                                    top: 8,
                                    right: 8,
                                    fontSize: 14,
                                    color: "#999",
                                }}
                                className="rotate-refresh"
                            >
                                <i className="fa fa-refresh" />
                            </div>
                        )}

                        {running_orders?.map((order, idx) => (
                            <div
                                onClick={() => this.props.router.navigate(`/running-order/${order?.unique_order_id}`)}
                                key={idx}
                                style={{
                                    flexShrink: 0,
                                    scrollSnapAlign: "center",
                                    borderRadius: 15,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    minWidth: 250,
                                    height: "100%",
                                    padding: "5px 10px",
                                    flex: "0 0 100%",
                                }}
                            >
                                {/* Restaurant Image */}
                                <img
                                    src={order.restaurant?.image ? order.restaurant.image : "https://via.placeholder.com/50"}
                                    alt={`restaurant-${idx}`}
                                    style={{
                                        width: 60,
                                        height: 60,
                                        borderRadius: 10,
                                        objectFit: "cover",
                                        boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
                                    }}
                                />

                                {/* Text Content */}
                                <div style={{
                                    flex: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "flex-start",
                                    gap: 3,
                                    lineHeight: 1.1
                                }}>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 2,
                                        }}
                                    >
                                        <div style={{fontWeight: "bold", fontSize: 14, textAlign: "left"}}>
                                            {order.restaurant?.name}
                                        </div>

                                        <div
                                            style={{
                                                fontSize: 12,
                                                lineHeight: "14px",
                                                textAlign: "left",
                                            }}
                                        >
                                            {order.orderitems[0].name} x{order.orderitems[0].quantity}
                                        </div>

                                        {order.orderitems.length > 1 && <div style={{
                                            fontSize: 12,
                                            fontWeight: "bold",
                                            lineHeight: "14px",
                                            textAlign: "left",
                                            color: "#5ba53e"
                                        }}>
                                            {(
                                                `+ ${order.orderitems.length - 1} more`
                                            )}
                                        </div>
                                        }
                                    </div>
                                    <div style={{display: "flex", justifyContent: "space-between", marginTop: 5}}>
                                        <span
                                            style={{fontWeight: "bold", fontSize: 12}}>₹{order.total.toFixed(2)}</span>
                                        <span
                                            style={{
                                                backgroundColor: statusColors[statusMap[order.orderstatus_id]] || "#999",
                                                fontWeight: "600",
                                                fontSize: 12,
                                                textTransform: "capitalize",
                                                padding: "4px 8px",
                                                borderRadius: 8,
                                            }}
                                        >
                                    {statusMap[order.orderstatus_id] || "Unknown"}
                                </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.user.user,
    is_running_orders: state.user.is_running_orders,
    running_order_status: state.user.running_order_status,
});

export function withRouter(Component) {
    return function ComponentWithRouterProp(props) {
        const navigate = useNavigate();
        const params = useParams();
        const location = useLocation();

        const router = React.useMemo(() => ({ navigate, params, location }), [navigate, params, location]);

        return <Component {...props} router={router} />;
    };
}

export default withRouter(
    connect(mapStateToProps, {checkUserRunningOrder, getRunningOrders})
    (Orders)
);
